<template>
  <div>
    <el-row :gutter="20">
      <el-col :md="24">
        <h5>Сертификат электронной подписи</h5>
        <el-select
          v-model="thumbprint"
          class="sertificateInpit full-width"
          placeholder="Выберите сертификат"
        >
          <!--new Date((new Date(this.arrComp[0].validTo).getTime()-10800000)).toLocaleString()-->
          <!--item.validTo-->
          <el-option
            v-for="(item, index) in arrComp"
            :key="index"
            :label="
              item.name +
                ' ' +
                new Date(
                  new Date(item.validTo).getTime() - 10800000
                ).toLocaleString()
            "
            :value="item.thumbprint"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-form ref="form" :model="form" class="mainForm" style="margin-top: 20px">
      <el-row :gutter="20">
        <el-col :md="12" :sm="12">
          <div class="blueBg">
            <el-col :md="5" :sm="7">
              <el-form-item label="ФЗ" prop="fz">
                <el-input v-model="normalFZ" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="14" :sm="17">
              <el-form-item label="Номер закупки" prop="tender_number">
                <el-input
                  v-model="form.tender_number"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="5" :sm="24">
              <el-form-item prop="link" label="Ссылка">
                <div
                  style="position: relative;display: inline-block;width: 100%;cursor: pointer"
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    @click="goLink(form.link)"
                  >
                    <g filter="url(#filter0_d)">
                      <g clip-path="url(#clip0)">
                        <path
                          d="M23.0909 0H15.8181C15.3161 0 14.909 0.407031 14.909 0.909102C14.909 1.41117 15.3161 1.8182 15.8181 1.8182H20.8961L11.539 11.1754C11.1839 11.5304 11.1839 12.106 11.539 12.461C11.7164 12.6385 11.9491 12.7273 12.1818 12.7273C12.4144 12.7273 12.6471 12.6386 12.8246 12.461L22.1818 3.10383V8.18184C22.1818 8.68391 22.5888 9.09094 23.0909 9.09094C23.593 9.09094 24 8.68391 24 8.18184V0.909102C24 0.407031 23.5929 0 23.0909 0Z"
                          fill="black"
                        />
                        <path
                          d="M19.4545 9.09088C18.9525 9.09088 18.5454 9.49791 18.5454 9.99999V18.1818H5.81816V5.45452H14C14.5021 5.45452 14.9091 5.04749 14.9091 4.54541C14.9091 4.04334 14.5021 3.63635 14 3.63635H4.9091C4.40703 3.63635 4 4.04338 4 4.54545V19.0909C4 19.593 4.40703 20 4.9091 20H19.4546C19.9566 20 20.3637 19.593 20.3637 19.0909V9.99999C20.3636 9.49791 19.9566 9.09088 19.4545 9.09088Z"
                          fill="black"
                        />
                      </g>
                    </g>
                    <defs>
                      <filter
                        id="filter0_d"
                        x="0"
                        y="0"
                        width="28"
                        height="28"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow"
                          result="shape"
                        />
                      </filter>
                      <clipPath id="clip0">
                        <rect x="4" width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <svg
                    width="20"
                    height="28"
                    viewBox="0 2 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    @click="copyStringToClipboard(form.link)"
                  >
                    <path
                      d="M12.1484 20H4.6875C2.96432 20 1.5625 18.5982 1.5625 16.875V6.28906C1.5625 4.56589 2.96432 3.16406 4.6875 3.16406H12.1484C13.8716 3.16406 15.2734 4.56589 15.2734 6.28906V16.875C15.2734 18.5982 13.8716 20 12.1484 20ZM4.6875 4.72656C3.82599 4.72656 3.125 5.42755 3.125 6.28906V16.875C3.125 17.7365 3.82599 18.4375 4.6875 18.4375H12.1484C13.0099 18.4375 13.7109 17.7365 13.7109 16.875V6.28906C13.7109 5.42755 13.0099 4.72656 12.1484 4.72656H4.6875ZM18.3984 14.9219V3.125C18.3984 1.40182 16.9966 0 15.2734 0H6.60156C6.17004 0 5.82031 0.349731 5.82031 0.78125C5.82031 1.21277 6.17004 1.5625 6.60156 1.5625H15.2734C16.1349 1.5625 16.8359 2.26349 16.8359 3.125V14.9219C16.8359 15.3534 17.1857 15.7031 17.6172 15.7031C18.0487 15.7031 18.3984 15.3534 18.3984 14.9219Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-form-item label="Предмет" prop="object">
                <el-input v-model="form.object" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-form-item label="Заказчик" prop="customer_name">
                <el-input
                  v-model="form.customer_name"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </div>
        </el-col>
        <el-col :md="12" :sm="12">
          <el-col :md="24">
            <el-form-item label="Заявитель" prop="name">
              <el-input v-model="form.name" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="ИНН" prop="inn">
              <el-input v-model="form.inn" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="КПП" prop="kpp">
              <el-input v-model="form.kpp" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="ОГРН" prop="ogrn">
              <el-input v-model="form.ogrn" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>
    </el-form>
    <br />
    <br />
    <el-row :gutter="20" v-if="!offer">
      <el-col :md="8" :sm="9">
        <div class="blueBg" style="padding: 20px;">
          <div class="greenBg">
            <h3 style="color:#fff;text-align: center">Заявки в банки:</h3>
          </div>
          <el-row :gutter="10">
            <div
              v-for="(bank, index) in banksComp"
              :key="bank.id"
              class="whiteBg"
              style="margin-top: 15px"
            >
              <el-col :md="4" :sm="5" :xs="5">
                <svg
                  width="31"
                  height="40"
                  viewBox="0 0 31 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 13L14.5 33.5L28.5 1"
                    stroke="#2FBFA6"
                    stroke-width="5"
                  />
                </svg>
              </el-col>
              <el-col :md="20" :sm="19" :xs="19"
                ><img width="100%" :src="bank.logo"
              /></el-col>
              <el-col :md="24">
                <h5
                  v-if="banks_noprogramm.includes(+bank.id)"
                  style="text-align: right"
                >
                  Подписывается на стороне банка
                </h5>
                <h6
                  style="text-decoration-line: underline;color: #C26767;text-align: right;cursor: pointer;"
                  @click="deleteBank(bank)"
                >
                  Удалить
                </h6></el-col
              >
            </div>
            <div
              v-for="(bank, index) in addbanksComp"
              :key="bank.id"
              class="whiteBg"
              style="margin-top: 15px"
            >
              <el-col :md="4" :sm="5" :xs="5">
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="15"
                    cy="15"
                    r="12.5"
                    stroke="#C26767"
                    stroke-width="5"
                  />
                  <line
                    y1="-2.5"
                    x2="23.6008"
                    y2="-2.5"
                    transform="matrix(-0.805056 -0.593199 -0.593199 0.805056 23 24)"
                    stroke="#C26767"
                    stroke-width="5"
                  />
                </svg>
              </el-col>
              <el-col :md="20" :sm="19" :xs="19"
                ><img width="100%" :src="bank.logo"
              /></el-col>
              <el-col :md="24">
                <h6
                  style="text-decoration-line: underline;color: #2FBFA6;text-align: right;cursor: pointer;"
                  @click="addBank(bank)"
                >
                  Добавить
                </h6></el-col
              >
            </div>
          </el-row>
        </div>
      </el-col>
      <el-col :md="16" :sm="15">
        <el-row :gutter="20">
          <el-col :md="12" :sm="12">
            <h4 style="line-height: 36px;margin: 0;">
              Документы на подпись
            </h4></el-col
          >
          <el-col :md="12" :sm="12" style="text-align: right">
            <el-button
              v-if="allSign === false"
              @click="signAnyDocument(noSignDocumentComp, 'doc')"
              class="fillBlueBtn"
              >Подписать документы</el-button
            >
            <h3 v-else-if="allSign === true">Документы подписаны</h3>
            <h3 v-else style="color: #d60a0d">Подписание документов...</h3>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          v-for="(item, index) in noSignDocumentComp"
          :key="index"
          style="margin-top: 20px"
        >
          <el-col :md="18">
            <h4 style="margin-bottom: 0">{{ index + 1 }}) {{ item.name }}</h4>
            <div v-if="showInfo(item.banks).length">
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.5 8.28573C14.5 11.7555 11.4091 14.6429 7.5 14.6429C3.59089 14.6429 0.5 11.7555 0.5 8.28573C0.5 4.81601 3.59089 1.92859 7.5 1.92859C11.4091 1.92859 14.5 4.81601 14.5 8.28573Z"
                  stroke="#2FBFA6"
                />
                <path
                  d="M8.2558 10.9897H7.03265L6.93744 3.33594H8.35834L8.2558 10.9897ZM6.88617 13.3188C6.88617 13.0991 6.95209 12.916 7.08392 12.7695C7.22064 12.6182 7.42084 12.5425 7.68451 12.5425C7.94818 12.5425 8.14838 12.6182 8.2851 12.7695C8.42181 12.916 8.49017 13.0991 8.49017 13.3188C8.49017 13.5386 8.42181 13.7217 8.2851 13.8682C8.14838 14.0098 7.94818 14.0806 7.68451 14.0806C7.42084 14.0806 7.22064 14.0098 7.08392 13.8682C6.95209 13.7217 6.88617 13.5386 6.88617 13.3188Z"
                  fill="#2FBFA6"
                />
              </svg>
              <span style="fint-size:12px">
                Направляется в
                <span v-for="(info, index) in showInfo(item.banks)" :key="info">
                  {{ correctBank(info) }}
                  {{ index === showInfo(item.banks).length - 1 ? "" : ", " }}
                </span>
              </span>
            </div>
          </el-col>
          <el-col :md="6">
            <!--{{item.sign}}-->
            <el-button
              v-if="item.filename && item.sign === false"
              @click="downloadDocument(item, $event)"
              class="greenBtn"
              >Скачать документ</el-button
            >
            <h3 v-if="item.sign === 'load'">Подписание...</h3>
            <h3 v-else-if="item.sign === true" style="color:#2FBFA6">
              Документ подписан
            </h3>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="blueBg" :gutter="20" v-else>
      <div
        class="greenBg"
        style="display: flex;flex-wrap: wrap;align-items: center;"
      >
        <el-col :md="6" :sm="6">
          <img :src="banks[0].logo" width="100%" />
        </el-col>
        <el-col :md="18" :sm="18">
          <h3 style="color:#fff;text-align: center;">
            Проект банковской гарантии
          </h3>
        </el-col>
      </div>
      <el-col :md="24" style="text-align: right">
        <el-button
          v-if="allSign === false"
          style="margin-top: 20px;margin-bottom: 20px"
          @click="signAnyDocument(offers, 'offer')"
          class="fillBlueBtn"
          >Подписать документы</el-button
        >
        <h3 v-else-if="allSign === true">Документы подписаны</h3>
        <h3 v-else style="color: #d60a0d">Подписание документов...</h3>
      </el-col>
      <div
        v-for="(offer, index) in offersComp"
        :key="index"
        style="overflow: hidden;clear: both"
      >
        <el-col :md="16" :sm="16" :xs="24"
          ><h4>{{ index + 1 }}.{{ offer.name }}</h4></el-col
        >
        <el-col :md="8" :sm="8" :xs="24" style="text-align: right">
          <el-button
            v-if="offer.filename && offer.sign === false"
            @click="downloadDocument(offer, $event)"
            class="greenBtn"
            >Скачать документ</el-button
          >
          <h3 v-if="offer.sign === 'load'">Подписание...</h3>
          <h3 v-else-if="offer.sign === true" style="color:#2FBFA6">
            Документ подписан
          </h3>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import { banks_noprogramm } from "../../utils/banks";
import { createSignature } from "crypto-pro";
// import FileInput from "@/components/inputFile/FileInput";
import { downloadOrganizationDocumentByName } from "@/api/organization/organization-document";
import { savesig, signoffer, error } from "@/api/sign";
import FileServer from "file-saver";
export default {
  name: "index",
  components: {
    // FileInput
  },
  data() {
    return {
      // form: {
      //   fz: "1",
      //   tender_number: "2",
      //   link: "3",
      //   object: "4",
      //   customer_name: "5",
      //   name: "6",
      //   inn: "7",
      //   kpp: "8",
      //   ogrn: "9"
      // },
      //banks:[],
      // noSignDocument:[],
      // thumbprintVal: this.thumbprint,
      fileCont: undefined,
      thumbprint: "",
      banks_noprogramm,
      arr_fz: ["44-ФЗ", "223-ФЗ", "615-ПП", "Коммерция"],
      allSign: false
      //  go: false
    };
  },
  props: [
    // "thumbprint",
    "arr",
    "formComp",
    "banks",
    "noSignDocument",
    "offer",
    "offers",
    "links"
  ],
  computed: {
    // thumbprintComp: {
    //   get() {
    //     return this.thumbprintVal;
    //   },
    //   set(value) {
    //     this.thumbprintVal = value;
    //   }
    // },
    normalFZ() {
      return this.arr_fz[this.form.fz];
    },
    arrComp() {
      // console.log('2')
      //  return [...this.arr];
       // console.log(this.arr.filter(cert => +cert.ogrn_count === +this.form.ogrn || cert.inn === this.form.inn))
     //return this.arr.filter(cert => cert.inn === this.form.inn); //тут подкорректировать инны
     return this.arr.filter(cert => +cert.ogrn_count === +this.form.ogrn || cert.inn === this.form.inn); //теперь по огрн смотрю
    },
    form() {
      return { ...this.formComp };
    },
    banksComp() {
      return this.banks.filter(bank => bank.status == true);
    },
    addbanksComp() {
      return this.banks.filter(bank => bank.status == false);
    },
    noSignDocumentComp() {
      //console.log('2')
      return [...this.noSignDocument];
    },
    offersComp() {
      return [...this.offers];
    }
  },
  created() {
    //console.log(this.arr)
    if (this.noSignDocument) {
      this.noSignDocument.forEach(item => {
        //console.log('1')
        this.$set(item, "sign", false);
        //this.testdownloadDocument(item)
      });
    }
    if (this.offers) {
      this.offers.forEach(item => {
        //console.log('1')
        this.$set(item, "sign", false);
        // this.testdownloadDocument(item)
      });
    }
    //console.log(this.arrComp);
    this.thumbprint =this.arrComp[0] ? this.arrComp[0].thumbprint : "";
   // console.log(this.thumbprint);
  },

  methods: {
    testdownloadDocument(file) {
      downloadOrganizationDocumentByName({ source: file.source })
        .then(response => {
          // console.log(response)
          this.$set(file, "cansign", true);
        })
        .catch(err => {
          // console.log('!!!!!')
          // console.log(err.response.status);
          if (+err.response.status === 404) {
            this.$set(file, "cansign", false);
          } else {
            this.$set(file, "cansign", true);
          }
          //console.log(this.noSignDocument)
        })
        .finally(() => {});
    },
    showInfo(banks) {
      let arr = [];
      for (let j = 0; j < banks.length; j++) {
        for (let i = 0; i < this.banksComp.length; i++) {
          if (+banks[j] === +this.banksComp[i].id) {
            arr.push(banks[j]);
          }
        }
      }
      banks = arr;
      return arr;
    },
    correctBank(info) {
      for (let i = 0; i < this.banksComp.length; i++) {
        if (this.banksComp[i].id === info) {
          return this.banksComp[i].name;
          break;
        }
      }
    },
    goLink(link) {
      window.open(link, "_blank");
    },
    copyStringToClipboard(str) {
      var el = document.createElement("textarea");
      el.value = str;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
    async signAnyDocument(document, type) {
      if (this.banksComp.length) {
        // console.log('1_1')
        this.allSign = "loading";
        let k = -1;
        for (const i of document) {
          //  if(i.cansign){
          //   console.log('2')
          i.sign = "load";
          k++;
          if (i.filename) {
            let blob;
            await new Promise(async res => {
              try {
                blob = (await downloadOrganizationDocumentByName({
                  source: i.source
                })).data;

                // fetch(
                //     'https://lk-api.isfg.ru/page-sign/download-by-name?source='+i.source,
                //     {
                //         headers: {
                //             'Accept': 'application/octet-stream',
                //         },
                //         responseType: 'blob',
                //     }
                // )
                //     .then(response => {
                //         console.log(response)
                //         if (response.ok) {
                //             //console.log(response.blob())
                //             return response.blob();
                //             //console.log(blob)
                //         }
                //     })
                //     .then(blob1 => {
                //         console.log(blob1)
                //         //blob=blob1
                //         blob = new Blob([blob1],{type: "blob"})
                //         //blob={...blob1, type:"blob"}
                //         console.log(blob)
                //     });

                res();
              } catch (e) {
                this.$notify.info({
                  title: "Информация!",
                  message: e.message
                });
                error({ text: e.message, bank_file_id: i.bank_file_id });
                this.allSign = false;
                i.sign = false;
              }
            });
            // console.log('3')
            const getfile = new File([blob], i.filename, {
              type: "text/plain"
            });
            let reader = new FileReader();
            reader.readAsDataURL(getfile);
            let th = this;
            await new Promise(async res => {
              // console.log('4')
              reader.onload = async function() {
                let header = ";base64,";
                let fileData = reader.result;
                th.fileCont = fileData.substr(
                  fileData.indexOf(header) + header.length
                );
                if (type === "doc") {
                  await th.sign(i, k);
                  res();
                  //  console.log('8')
                } else {
                  th.signOffer(i, k);
                  res();
                }
              };
            });
          }
          // }else{
          //     this.$notify.info({
          //         title: "Внимание!",
          //         message: `Документ ${i.name} не подписывается. Обратитесь к персональному менеджеру.`,
          //         type: 'warning',
          //         duration:0
          //     });
          // }
        }
        console.log("9");
        this.allSign = true;
      } else {
        this.$notify.info({
          title: "Информация!",
          message: `Документы не посылаются ни в один банк.`
        });
      }
      let banks_name = [];
      if (!this.offer) {
        for (let i = 0; i < this.links.length; i++) {
          for (let j = 0; j < this.banksComp.length; j++) {
            if (+this.links[i].bank_id === this.banksComp[j].id) {
              banks_name.push(this.links[i]);
            }
          }
        }
      } else {
        for (let i = 0; i < this.links.length; i++) {
          if (+this.links[i].bank_id === this.banks[0].id) {
            banks_name.push(this.links[i]);
          }
        }
      }
      let a;
      for (let k = 0; k < banks_name.length; k++) {
        a = banks_name[k].name + (k === banks_name.length - 1 ? "." : ",");
        setTimeout(() => {
          window.open(banks_name[k].link, "_blank");
        }, 3000);
      }
      if (a) {
        this.$notify.info({
          title: "Информация!",
          message: `Для подписание документов Вы будете направлены на страницы банков: ${a}`
        });
      }
    },
    async sign(item, index) {
      //console.log('5')
      await new Promise(async resolve => {
        //  console.log('6')
        try {
          //throw new Error('q')
          // console.log('7')
          if(item.banks.indexOf(13)!==-1){
            //приерепленная для альфа банка
            this.signature = await createSignature(
                this.thumbprint,
                this.fileCont,
                false
            );
          }else{
            this.signature = await createSignature(
                this.thumbprint,
                this.fileCont,
                true
            );
          }
          await savesig({
            signature: this.signature,
            filename: item.filename,
            source: item.source,
            id: item.id,
            bank_file_id: item.bank_file_id,
            array_bank: Array.from(this.banksComp, ({ id }) => id)
          });
          item.sign = true;
          // console.log('7_1')
          resolve();
          // console.log('10')
        } catch (err) {
          this.$notify.error({
            title: "Ошибка",
            message: err.message
          });
          error({ text: err.message, bank_file_id: item.bank_file_id });
          this.allSign = false;
          item.sign = false;
        }
      });
    },
    async signOffer(item, index) {
      await new Promise(async resolve => {
        try {
          this.signature = await createSignature(
            this.thumbprint,
            this.fileCont,
            true
          );
          await signoffer({
            signature: this.signature,
            filename: item.filename,
            source: item.source,
            bank_file_id: item.bank_file_id,
            id: item.id
          });
          item.sign = true;
          resolve();
        } catch (err) {
          this.$notify.error({
            title: "Ошибка",
            message: err.message
          });
          error({ text: err.message, bank_file_id: item.bank_file_id });
          this.allSign = false;
          item.sign = false;
        }
      });
    },
    deleteBank(bank) {
      bank.status = false;
    },
    addBank(bank) {
      bank.status = true;
    },
    async downloadDocument(file, event) {
      // console.log(file)
      // console.log(event)
      event.preventDefault();
      // let a = (await downloadOrganizationDocumentByName({source: file.source}))
      //    console.log(a)
      //    console.log(a.data)
      //  let b = new Blob([a.data])
      //  console.log(b)

      //        let response = await fetch('https://lk-api.isfg.ru/page-sign/download-by-name?source='+file.source);
      // console.log(response)
      //        let blob = await response.blob(); // скачиваем как Blob-объект
      //        blob = new Blob([blob])
      //        console.log(blob)
      //        FileServer.saveAs(blob, file.filename);

      // fetch(
      //     'https://lk-api.isfg.ru/page-sign/download-by-name?source='+file.source,
      //     {
      //         method: 'GET',
      //         headers: {
      //             'Accept': 'application/octet-stream',
      //         },
      //         responseType: 'blob',
      //     }
      // )
      //     .then(response => {
      //         if (response.ok) {
      //             //console.log(response.blob())
      //             return response.blob();
      //         }
      //     })
      //     .then(blob => {
      //         console.log(blob)
      //         //blob = new Blob([blob],{type: "blob"})
      //         //console.log(blob)
      //         FileServer.saveAs(blob, file.filename);
      //     });

      downloadOrganizationDocumentByName({ source: file.source })
        .then(response => {
          FileServer.saveAs(
            new Blob([response.data], {
              type: response.headers["content-type"]
            }),
            file.filename
          );
        })
        .catch(err => {
          console.log(err);
          // this.$notify.info({
          //     title: "Внимание!",
          //     message: `Документ не может скачаться. Попробуйте скачать в другом браузере.`,
          //     duration:0
          // });
        })
        .finally(() => {});
    }
  }
};
</script>
<style>
.sertificateInpit .el-input__inner {
  background: rgba(8, 159, 193, 0.15);
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
</style>
<style scoped>
h5 {
  margin: 0 0 5px;
}
</style>
